/*
 * Copyright (c) 2024, King Living
 * Configuration Selector Theme — assembled from slice files.
 * Each slice owns a logical UI area; this file merges them into the single
 * Chakra multi-style config object consumed by useMultiStyleConfig('ConfigurationSelector').
 *
 * `defineMultiStyleConfig` ensures part styles (e.g. responsive `color`) are resolved like other
 * project components; a plain `{ parts, baseStyle }` object can omit token/breakpoint processing.
 */

import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import {triggerCardParts, triggerCardBaseStyle} from './trigger-card';
import {panelShellParts, panelShellBaseStyle} from './panel-shell';
import {selectorTileParts, selectorTileBaseStyle} from './selector-tile';
import {subtotalFooterParts, subtotalFooterBaseStyle} from './subtotal-footer';
import {stepTilesParts, stepTilesBaseStyle} from './step-tiles';
import {coverStepParts, coverStepBaseStyle} from './cover-step';
import {optionStepParts, optionStepBaseStyle} from './option-step';
import {chooseYourSetsParts, chooseYourSetsBaseStyle} from './choose-your-sets';
import {selectedSummaryParts, selectedSummaryBaseStyle} from './selected-summary';

const configurationSelectorParts = [
  ...triggerCardParts,
  ...panelShellParts,
  ...selectorTileParts,
  ...subtotalFooterParts,
  ...stepTilesParts,
  ...coverStepParts,
  ...optionStepParts,
  ...chooseYourSetsParts,
  ...selectedSummaryParts,
];

const {defineMultiStyleConfig} = createMultiStyleConfigHelpers(configurationSelectorParts);

const ConfigurationSelector = defineMultiStyleConfig({
  baseStyle: {
    ...triggerCardBaseStyle,
    ...panelShellBaseStyle,
    ...selectorTileBaseStyle,
    ...subtotalFooterBaseStyle,
    ...stepTilesBaseStyle,
    ...coverStepBaseStyle,
    ...optionStepBaseStyle,
    ...chooseYourSetsBaseStyle,
    ...selectedSummaryBaseStyle,
  },
});

export default ConfigurationSelector;
